import {
  FOR_LAYWERS_PAGE_TITLE,
  FOR_LAYWERS_PAGE_DESCRIPTION,
} from '@/shared/constants/seoConstants';
import { FOR_LAYWERS_FAQ_QUESTIONS } from '@/shared/constants/faqConstants';
import { ROOT_URL_HOST } from '@/shared/constants/contactConstants';
import { ROOT_LAWYERS_PAGE_URL } from '@/shared/constants/urlConstants';
import {
  buildBreadcrumbData,
  buildFaqData,
  type BreadcrumbSchemaData,
  type FaqSchemaData,
} from '@/shared/utils/buildSchemaData';

export const breadcrumbData: BreadcrumbSchemaData = buildBreadcrumbData([
  { name: 'Главная', url: '/' },
  { name: 'Клиенты юристам', url: ROOT_LAWYERS_PAGE_URL },
]);

export const webPageData: Record<string, unknown> = {
  name: FOR_LAYWERS_PAGE_TITLE,
  description: FOR_LAYWERS_PAGE_DESCRIPTION,
  url: `${ROOT_URL_HOST}${ROOT_LAWYERS_PAGE_URL}`,
};

export const faqData: FaqSchemaData = buildFaqData(FOR_LAYWERS_FAQ_QUESTIONS);
